<template>

  <vx-card :title="$t('live-class-schedule.class-room-and-unit')" class="mb-4">

    <template slot="actions">
      <vs-checkbox class="inline-flex" v-model="advisorOnlineScheduleEdit.form.advisorOnlineScheduleInput.isEnabled">
        {{$t('live-class-schedule.is-enabled')}}
      </vs-checkbox>
    </template>

    <div class="vx-row mb-3">
      <div class="vx-col sm:w-1/2 w-full">
        <ValidationProvider :name="$t('class-room.class-room')" rules="required" v-slot="{ errors }">
          <label class="text-sm">{{$t('class-room.class-room') + ' *'}}</label>
          <v-select :dir="$vs.rtl ? 'rtl' : 'ltr'" :name="$t('class-room.class-room')"
                    :options="classRooms" @input="onClassRoomChange"
                    @search="fetchOptions"
                    :clearable="false"
                    selectOnTab
                    label="nameLocal"
                    class="w-full mb-1"
                    v-model="local.classRoomEdit.selectedClassRoom">

            <!--label option-->
            <template #selected-option="option">
              {{ option.nameLocal }}
              {{$t('class-over-view.section-short')}} {{ option.classSection.sectionNo }}
              {{$t('class-over-view.learn-span-no-short')}} {{ option.classSection.learnSpanNo }}
              | {{ option.courseOutlineRegistration.periodCode }}
            </template>

            <!--option list-->
            <template v-slot:option="option">
              {{ option.nameLocal }}
              {{$t('class-over-view.section-short')}} {{ option.classSection.sectionNo }}
              {{$t('class-over-view.learn-span-no-short')}} {{ option.classSection.learnSpanNo }}
              | {{ option.courseOutlineRegistration.periodCode }}
              <!--<br>
              {{ $t('live-class-schedule.teacher') }} {{ classRooms.teacher.firstNameLocal + ' ' + classRooms.teacher.lastNameLocal}}-->
            </template>

            <template v-slot:no-options="{ search, searching }">
              <template v-if="searching">
                {{$t('general.no-result-for')}} <em>{{ search }}</em>.
              </template>
              <em style="opacity: 0.5;" v-else>{{$t('live-class-schedule.type-name-to-search')}}</em>
            </template>

          </v-select>

          <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
        </ValidationProvider>
      </div>
    </div>

    <vs-divider/>

    <!---------------------------------------- Class Room Desc ------------------------------------------>

    <div class="vx-row text-center">
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <span>
          <p class="text-l font-semibold">
            <span>{{ studentRegisterQty }}</span>/{{ capacity }}
          </p>
          <small class="text-grey">{{ $t('student-enroll.student-qty') }}</small>
        </span>
      </div>
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <span>
          <p class="text-l font-semibold">
            {{ startDate }}
          </p>
          <small class="text-grey">{{ $t('class-room.start-date') }}</small>
        </span>
      </div>
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <span>
          <p class="text-l font-semibold">
            {{ endDate }}
          </p>
          <small class="text-grey">{{ $t('class-room.end-date') }}</small>
        </span>
      </div>
    </div>

    <div class="vx-row">
      <vs-alert :active="showWarningNoClassRoom" color="warning" icon="icon-alert-triangle" icon-pack="feather">
        {{ $t('live-class-schedule.warning-no-class-room') }}
      </vs-alert>
    </div>

  </vx-card>

</template>

<script>
  import {state, getClassSectionById} from '../data';
  import vSelect from 'vue-select';
  import moment from 'moment';
  import {dateTimeFormat} from "@/utils/format";

  import AdvisorOnlineSchedule from '@/store/modules/advisor-online-schedule/index';
  import ClassRoom from '@/store/modules/courses/course-outline-registration/index';
  import ClassSection from '@/store/modules/courses/class-section/index';
  import {createNamespacedHelpers} from "vuex";
  import {createHelpers} from "vuex-map-fields";

  if (!state.store.AdvisorOnlineSchedule) state.registerModule(`AdvisorOnlineSchedule`, AdvisorOnlineSchedule);
  if (!state.store.ClassRoom) state.registerModule(`ClassRoom`, ClassRoom);
  if (!state.store.ClassSection) state.registerModule(`ClassSection`, ClassSection);

  const {
    mapActions: mapAdvisorOnlineScheduleActions,
  } = createNamespacedHelpers(`AdvisorOnlineSchedule`);
  const {
    mapActions: mapClassRoomActions,
  } = createNamespacedHelpers(`ClassRoom`);
  const {
    mapActions: mapClassSectionActions,
  } = createNamespacedHelpers(`ClassSection`);


  const {
    mapFields: mapAdvisorOnlineScheduleFields,
  } = createHelpers({
    getterType: `AdvisorOnlineSchedule/getField`,
    mutationType: `AdvisorOnlineSchedule/updateField`,
  });
  const {
    mapFields: mapClassRoomFields,
  } = createHelpers({
    getterType: `ClassRoom/getField`,
    mutationType: `ClassRoom/updateField`,
  });
  const {
    mapFields: mapClassSectionFields,
  } = createHelpers({
    getterType: `ClassSection/getField`,
    mutationType: `ClassSection/updateField`,
  });

  export default {
    components: {
      vSelect
    },
    data() {
      return {
        store: state.store,
        local: state.local,

        classRoomEdit: state.local.classRoomEdit,
        subjectInfo: state.local.subjectInfo,
        teacherEdit: state.local.teacherEdit,
        advisorOnlineScheduleEdit: state.local.advisorOnlineScheduleEdit,
      }
    },
    computed: {
      ...mapAdvisorOnlineScheduleFields({advisorOnlineScheduleProcessing: 'processing'}),
      ...mapClassRoomFields({classRoomProcessing: 'processing'}),
      ...mapClassSectionFields({classSectionProcessing: 'processing'}),
      classRooms() {
        return this.classRoomEdit.classRooms;
      },
      studentRegisterQty() {
        let studentRegisterQty = '-';
        if (this.classRoomEdit.selectedClassRoom) {
          studentRegisterQty = this.classRoomEdit.selectedClassRoom.studentRegisterQty;
        }
        return studentRegisterQty;
      },
      capacity() {
        let capacity = '-';
        if (this.classRoomEdit.selectedClassRoom) {
          capacity = this.classRoomEdit.selectedClassRoom.capacity;
        }
        return capacity;
      },
      startDate() {
        let startDate = '-';
        if (this.classRoomEdit.selectedClassRoom) {
          startDate = moment(this.classRoomEdit.selectedClassRoom.startDate).format(dateTimeFormat.momentYYYYMMDD);
        }
        return startDate;
      },
      endDate() {
        let endDate = '-';
        if (this.classRoomEdit.selectedClassRoom) {
          endDate = moment(this.classRoomEdit.selectedClassRoom.endDate).format(dateTimeFormat.momentYYYYMMDD);
        }
        return endDate;
      },
      showWarningNoClassRoom() {
        return this.local.showWarningNoClassRoom;
      }
    },
    watch: {
      advisorOnlineScheduleProcessing(data) {
        this.local.isProcessing = data;
      },
      classRoomProcessing(data) {
        this.local.isProcessing = data;
      },
      classSectionProcessing(data) {
        this.local.isProcessing = data;
      },
    },
    methods: {
      //---------------------------------------- State Function ------------------------------------------------------//
      ...mapAdvisorOnlineScheduleActions({
        getAdvisorOnlineSchedulesByFilter: 'getAdvisorOnlineSchedulesByFilter',
      }),
      ...mapClassRoomActions({
        getLearningClassRoomsDdl: 'getLearningClassRoomsDdl',
      }),
      ...mapClassSectionActions({
        getClassSection: 'getClassSection',
      }),
      //---------------------------------------- Event Function ------------------------------------------------------//
      async onClassRoomChange() {
        let func = {
          getClassSection: this.getClassSection,
        }
        await getClassSectionById(func);

        //set teacher
        if (this.classRoomEdit.selectedClassRoom) {
          this.teacherEdit.selectedTeacher = this.classRoomEdit.selectedClassRoom.teacher
        }
      },
      async fetchOptions(search, loading) {
        if(search && search.length >= 2){
          loading(true);
          this.classRoomEdit.classRooms  = await this.getLearningClassRoomsDdl({name:search, limit:20});
          loading(false);
        }else{
          this.classRoomEdit.classRooms = [];
        }
      },
      //---------------------------------------- Local Function ------------------------------------------------------//
      /*async initData() {
        if (!this.classRoomEdit.classRooms || this.classRoomEdit.classRooms.length === 0) {
          this.classRoomEdit.classRooms = await this.getLearningClassRooms();
        }
      },*/

    },
    async mounted() {
      // await this.initData();
    }
  }

</script>

<style scoped>

</style>
